export enum CounterSensorOptionEnum {
    WATER = 'water',
    GAS = 'gas',
    HEATING = 'heating',
    POWER = 'power',
}
